import { type ComponentProps, type ReactNode, useId } from "react";
import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

import type { InputProps } from "./input";

import { Input } from "./input";
import { inputStyle } from "./input.styles";
import { Label } from "./label";

export function TextField({ ref, label, errorMessage, children, prefix, helper, clearable, onClear, placeholder, ...props }: InputProps & { label?: string; errorMessage?: string; rootClassName?: string; helper?: string; clearable?: boolean; onClear?: () => void }) {
  const id = useId();
  const { t } = useTranslation(["common"]);

  return (
    <RootField className={!label ? "gap-0" : undefined}>
      {label && <Label htmlFor={id}>{label}</Label>}
      {helper && <span className="text-sm text-neutral-450">{helper}</span>}
      <Input {...props} id={id} ref={ref} prefix={prefix} clearable={clearable} onClear={onClear} placeholder={placeholder || t("common:type-text")} />
      {errorMessage && <ErrorField>{errorMessage}</ErrorField>}
    </RootField>
  );
};

export function TextAreaField({ ref, label, errorMessage, children, className, placeholder, ...props }: ComponentProps<"textarea"> & { label: ReactNode; errorMessage?: string }) {
  const id = useId();
  const { t } = useTranslation(["common"]);

  return (
    <RootField>
      <Label htmlFor={id}>{label}</Label>
      <textarea
        className={inputStyle(false, false, className,
        )}
        {...props}
        id={id}
        ref={ref}
        placeholder={placeholder || t("common:type-text")}
      />
      {errorMessage && <ErrorField>{errorMessage}</ErrorField>}
    </RootField>
  );
};

export function RootField({ className, ...props }: ComponentProps<"div">) {
  return (
    <div className={cn("flex w-full flex-col gap-2", className)} {...props} />
  );
}

export function ErrorField({ className, ...props }: ComponentProps<"span">) {
  return <span className={cn("text-sm text-red-500", className)} {...props} />;
}
